import React from "react"
import { connect } from "react-redux"
import { bool, element } from "prop-types"

const Loading = ({ children, loading }) => {
  return (
    <>
      {children}
      {loading && (
        <div className="loading -panel">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </>
  )
}

Loading.defaultProps = {
  loading: true,
}

Loading.propTypes = {
  children: element.isRequired,
  loading: bool,
}

export default connect(state => ({
  loading: state.loading,
}))(Loading)
